
/* START_TEMPLATE */
define('hbs!pricelist/templates/technical',['hbs','handlebars','templates/helpers/unlessZero'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
helpers = helpers || Handlebars.helpers;
  var buffer = "", stack1, stack2, options, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n<section class=\"adservingsystems\">\r\n  <h4>Annonssystem</h4>\r\n  <ul class=\"adservingsystem-list\">\r\n    ";
  stack1 = helpers.each.call(depth0, depth0.AdServingSystems, {hash:{},inverse:self.noop,fn:self.program(2, program2, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n  </ul>\r\n</section>\r\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "";
  buffer += "\r\n    <li class=\"system\">\r\n      "
    + escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0))
    + "\r\n    </li>\r\n    ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\r\n  ";
  options = {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data)};
  stack2 = ((stack1 = helpers.unlessZero),stack1 ? stack1.call(depth0, depth0.AdServingSystems, options) : helperMissing.call(depth0, "unlessZero", depth0.AdServingSystems, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n";
  return buffer;
  }
function program5(depth0,data) {
  
  
  return "\r\n  ";
  }

function program7(depth0,data) {
  
  
  return "\r\n    Information saknas.\r\n  ";
  }

function program9(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n<section class=\"adspecifications\">\r\n  <h4>Annonsspecifikation</h4>\r\n  ";
  stack1 = helpers.each.call(depth0, depth0.AdSpecifications, {hash:{},inverse:self.noop,fn:self.program(10, program10, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n</section>\r\n";
  return buffer;
  }
function program10(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n  <div class=\"unit span8\">\r\n    <table class=\"table table-definition\">\r\n      ";
  stack1 = helpers['if'].call(depth0, depth0.Text, {hash:{},inverse:self.noop,fn:self.program(11, program11, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n      ";
  stack1 = helpers['if'].call(depth0, depth0.CreativeNames, {hash:{},inverse:self.noop,fn:self.program(13, program13, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n      ";
  stack1 = helpers['if'].call(depth0, depth0.MaxInitialWeight, {hash:{},inverse:self.noop,fn:self.program(15, program15, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n      ";
  stack1 = helpers['if'].call(depth0, depth0.MaxAdditionalWeight, {hash:{},inverse:self.noop,fn:self.program(17, program17, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n      ";
  stack1 = helpers['if'].call(depth0, depth0.AnimationLength, {hash:{},inverse:self.noop,fn:self.program(19, program19, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n      ";
  stack1 = helpers['if'].call(depth0, depth0.Fps, {hash:{},inverse:self.noop,fn:self.program(21, program21, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n      ";
  stack1 = helpers['if'].call(depth0, depth0.Sound, {hash:{},inverse:self.noop,fn:self.program(23, program23, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n      ";
  stack1 = helpers['if'].call(depth0, depth0.HasBackupImage, {hash:{},inverse:self.noop,fn:self.program(25, program25, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n      ";
  stack1 = helpers['if'].call(depth0, depth0.OnEditorialText, {hash:{},inverse:self.noop,fn:self.program(27, program27, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n      ";
  stack1 = helpers['if'].call(depth0, depth0.ClickTag, {hash:{},inverse:self.noop,fn:self.program(29, program29, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n    </table>\r\n  </div>\r\n  ";
  return buffer;
  }
function program11(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n      <tr style=\"\">\r\n        <td>Text</td><td>";
  if (stack1 = helpers.Text) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.Text; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n      </tr>\r\n      ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n      <tr>\r\n        <td>Filformat</td>\r\n        <td>";
  if (stack1 = helpers.CreativeNames) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.CreativeNames; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n      </tr>\r\n      ";
  return buffer;
  }

function program15(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n      <tr>\r\n        <td>Max filstorlek</td>\r\n        <td>";
  if (stack1 = helpers.MaxInitialWeight) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.MaxInitialWeight; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n      </tr>\r\n      ";
  return buffer;
  }

function program17(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n      <tr>\r\n        <td>Max storlek på streaming media</td>\r\n        <td>";
  if (stack1 = helpers.MaxAdditionalWeight) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.MaxAdditionalWeight; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n      </tr>\r\n      ";
  return buffer;
  }

function program19(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n      <tr>\r\n        <td>Längd</td>\r\n        <td>";
  if (stack1 = helpers.AnimationLength) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.AnimationLength; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n      </tr>\r\n      ";
  return buffer;
  }

function program21(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n      <tr>\r\n        <td>Frekvens</td>\r\n        <td>";
  if (stack1 = helpers.Fps) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.Fps; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n      </tr>\r\n      ";
  return buffer;
  }

function program23(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n      <tr>\r\n        <td>Ljud</td>\r\n        <td>";
  if (stack1 = helpers.Sound) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.Sound; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n      </tr>\r\n      ";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n      <tr>\r\n        <td>Backup-bild</td>\r\n        <td>";
  if (stack1 = helpers.HasBackupImage) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.HasBackupImage; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n      </tr>\r\n      ";
  return buffer;
  }

function program27(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n      <tr>\r\n        <td>Över redaktionell text</td>\r\n        <td>";
  if (stack1 = helpers.OnEditorialText) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.OnEditorialText; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n      </tr>\r\n      ";
  return buffer;
  }

function program29(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n      <tr>\r\n        <td>Click-Tag</td>\r\n        <td>";
  if (stack1 = helpers.ClickTag) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.ClickTag; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n      </tr>\r\n      ";
  return buffer;
  }

  buffer += "<a href=\"#\" class=\"close\">&times;</a>\r\n\r\n<h3 class=\"title\">Materialspec.</h3>\r\n\r\n";
  options = {hash:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data)};
  stack2 = ((stack1 = helpers.unlessZero),stack1 ? stack1.call(depth0, depth0.AdServingSystems, options) : helperMissing.call(depth0, "unlessZero", depth0.AdServingSystems, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n\r\n";
  options = {hash:{},inverse:self.noop,fn:self.program(9, program9, data)};
  stack2 = ((stack1 = helpers.unlessZero),stack1 ? stack1.call(depth0, depth0.AdSpecifications, options) : helperMissing.call(depth0, "unlessZero", depth0.AdSpecifications, options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n\r\n\r\n\r\n\r\n\r\n";
  return buffer;
  });
Handlebars.registerPartial('pricelist_templates_technical', t);
return t;
});
/* END_TEMPLATE */
;
